function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.999 19.998a10 10 0 117.073-2.93 9.927 9.927 0 01-7.073 2.93zm-.624-6.5v1.5h1.55v-1.5zm.054-8.611l.18 7.211h1.052l.18-7.211z",
  fill: "#fff"
});

function SvgErrorIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.998,
    height: 19.998
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19.998' height='19.998'%3E%3Cpath d='M9.999 19.998a10 10 0 117.073-2.93 9.927 9.927 0 01-7.073 2.93zm-.624-6.5v1.5h1.55v-1.5zm.054-8.611l.18 7.211h1.052l.18-7.211z' fill='%23fff'/%3E%3C/svg%3E";
export { SvgErrorIconWhite as ReactComponent };